export default "__VITE_ASSET__25092b92__"